import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { TextField } from "@mui/material";

const StyledTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "#f2006c !important",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#f2006c",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#f2006c",
    },
    "&:hover fieldset": {
      borderColor: "#f2006c",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#f2006c",
    },
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
      display: "none",
    },
    "& input[type=number]": {
      MozAppearance: "textfield",
    },
  },
});

export default function TextFieldAuth(props) {
  const [inputKey, setInputKey] = useState(Date.now());

  useEffect(() => {
    const handleAutofill = () => {
      document.querySelectorAll('input:-webkit-autofill').forEach((input) => {
        const label = input.closest('.MuiFormControl-root')?.querySelector('label');
        if (label) {
          label.classList.add('MuiInputLabel-shrink');
        }
        setInputKey(Date.now());
      });
    };

    const autofillTimer = setTimeout(handleAutofill, 200);

    return () => clearTimeout(autofillTimer); 
  }, []);

  return (
    <StyledTextField
      key={inputKey}
      {...props}
      autoComplete={props.autoComplete}
    />
  );
}
